<script setup>
  import { ref, onMounted, watchEffect, useTemplateRef } from 'vue';
  import useLegacyBridge from "@/composables/useLegacyBridge";

  const props = defineProps({
    profileId: {
      type: Number,
      required: true,
    }
  });

  const mapContainer = useTemplateRef('map-container');

  const { cosmos } = useLegacyBridge();

  const cosmosUI = ref(null);

  const uiOptions = {
      useJwxUI: false,
      regionalProducts: {
          productSettings: {
              "favoriteList": {
                  name: "My Favorites",
                  description: "Your favorite spot list.",
                  mapMode: "obs",
                  overlays: {"markers": {data: [1,100,101], loc: [1,100,101]}}
              }    
          }
      },                
      viewId: "favoriteList",
      legend: {
          allowClose: false,
          obsLegend: {
              isHurrnet: false
          },
          targetSelector: "[data-map=legend-favorite-spots]"
      } 
    };

    const mapOptions = {
      searchType: "profile",
      profileId: props.profileId,
    };       

    function loadCosmos() {


      cosmosUI.value = cosmos(mapContainer.value, uiOptions, mapOptions)
    }

    watchEffect(() => {
      if (mapContainer.value) loadCosmos();
    });

</script>

<template>
  <div
    ref="map-container"
    :id="`favortied-map-${props.containerId}`"
    class="jwx-favorited-map"
    style="height: 400px; width: 100%; overflow: hidden; position: relative;"
  ></div>
  <div class="jwx-favorited-map__legend" :data-map="`legend-favorite-spots`"></div>
</template>